import "./../style/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="copyright">© The Artistry 2023</p>
    </footer>
  );
};
export default Footer;
